'use client';
import { IonButton } from '@ionic/react';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'next-share';
import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Clipboard } from '@capacitor/clipboard';
import { IonIcon } from '@ionic/react';
import { shareOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

export default function ShareForm({ profileId, className }: { profileId: string; className?: React.ComponentProps<'div'> }) {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();
  const handleCopy = async () => {
    const profileLink = `https://face.golf/${profileId}`;

    await Clipboard.write({
      string: profileLink
    });

    setCopied(true);
    // Reset the copied state after a timeout
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSystemShare = async () => {
    const profileUrl = `${window.location.origin}/u/${profileId}`;
    const shareText = t('share_profile_text', { profileId });

    // Check if we're on a native platform with Share plugin available
    if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Share')) {
      await Share.share({
        title: t('share_profile_title'),
        text: shareText,
        url: profileUrl,
        dialogTitle: t('share_profile_dialog_title'),
      });
    };
  };

  return (
    <div className='grid items-center gap-4 p-3'>
      <div className="flex justify-center flex-col items-center">
        <QRCodeSVG
          className="rounded-t-lg bg-white p-4 shadow-lg"
          value={`https://face.golf/u/${profileId}`}
          size={200}
        />
        <span className="w-[200px] text-lg font-extrabold bg-green-500 text-white px-4 py-2 rounded-b-lg shadow-lg">
          @{profileId}
        </span>
      </div>
      <div className="space-x-2 flex items-center justify-center w-full">

        <IonButton type="button" fill="outline" shape="round" className="rounded-full text-muted-foreground size-12" onClick={handleSystemShare}>
          <IonIcon slot="icon-only" icon={shareOutline} className="size-6" />
        </IonButton>
        <FacebookShareButton url={`https://face.golf/${profileId}`} quote="Checkout my golf profile">
          <FacebookIcon size={48} round />
        </FacebookShareButton>
        <WhatsappShareButton url={`https://face.golf/${profileId}`} title="My golf profile" content="Check my golf profile here:">
          <WhatsappIcon size={48} round />
        </WhatsappShareButton>
        <TwitterShareButton url={`https://face.golf/${profileId}`} content="Check my golf profile here:" hashtags={['golf', 'MGP']}>
          <TwitterIcon size={48} round />
        </TwitterShareButton>
        <LinkedinShareButton url={`https://face.golf/${profileId}`}>
          <LinkedinIcon size={48} round />
        </LinkedinShareButton>
        <EmailShareButton url={`https://face.golf/${profileId}`} subject="Share profile" body="Check out this link!">
          <EmailIcon size={48} round />
        </EmailShareButton>
      </div>
      <IonButton type="button" color="medium" fill="clear" className="border bg-muted border-input rounded-full" onClick={handleCopy}>
        <div className="flex items-center justify-between w-full">
          face.golf/
          {profileId}
          <span className={copied ? 'text-green-500' : ''}>
            {copied ? t('copied') : t('copy')}
          </span>
        </div>
      </IonButton>
    </div >
  );
}

